import React from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";

export const TABLE_COLUMN_DOC_REF_CONFIG = {
    FJ: (handleSelectDocumentReference) => {
        return [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            {
                name: "tanggalFJ",
                label: "Tanggal FJ",
                options: {
                    sort: false
                }
            },
            {
                name: "nomorFJ",
                label: "Nomor FJ",
                options: {
                    sort: false
                }
            },
            {
                name: "namaPembeli",
                label: "Nama Pembeli",
                options: {
                    sort: false
                }
            },
            {
                name: "action",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => (
                        <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                            <SimpleButton
                                type="button"
                                text="Pilih"
                                onClick={() => handleSelectDocumentReference(tableMeta.rowIndex)}
                            />
                        </FlexView>
                    ),
                    options: {sort: false}
                },
            }
        ]
    } ,
    SO: (handleSelectDocumentReference) => {
        return [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            {
                name: "tanggalSO",
                label: "Tanggal SO",
                options: {
                    sort: false
                }
            },
            {
                name: "nomorSO",
                label: "Nomor SO",
                options: {
                    sort: false
                }
            },
            {
                name: "jenisSO",
                label: "Jenis SO",
                options: {
                    sort: false
                }
            },
            {
                name: "kodeLocator",
                label: "Lokasi",
                options: {
                    sort: false
                }
            },
            {
                name: "action",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => (
                        <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                            <SimpleButton
                                type="button"
                                text="Pilih"
                                onClick={() => handleSelectDocumentReference(tableMeta.rowIndex)}
                            />
                        </FlexView>
                    ),
                    options: {sort: false}
                },
            }
        ]
    },
    Fjb: (handleSelectDocumentReference) => {
        return [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            {
                name: "tanggalFjb",
                label: "Tanggal FJB",
                options: {
                    sort: false
                }
            },
            {
                name: "nomorFjb",
                label: "Nomor FJB",
                options: {
                    sort: false
                }
            },
            {
                name: "namaPembawa",
                label: "Nama Pembawa",
                options: {
                    sort: false
                }
            },
            {
                name: "namaPemilik",
                label: "Nama Pemilik",
                options: {
                    sort: false
                }
            },
            {
                name: "action",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => (
                        <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                            <SimpleButton
                                type="button"
                                text="Pilih"
                                onClick={() => handleSelectDocumentReference(tableMeta.rowIndex)}
                            />
                        </FlexView>
                    ),
                    options: {sort: false}
                },
            }
        ]
    }
}